// extracted by mini-css-extract-plugin
module.exports = {"input":"_base-input-text_input_cKPEQ"};